import React, { useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import InputStandard from "../Inputs/InputStandard";
import { Alert, Button, Card, CardBody, Col, Row } from "reactstrap";
import useTemplates from "../../context/hooks/useTemplates";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import axios from "axios";
import JoditEditor from "jodit-react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import parse from "html-react-parser";

const draftToHtml = require("draftjs-to-html");

const Font = Quill.import("formats/font") as any;
Font.whitelist = ["sans-serif", "serif", "monospace"];
Quill.register(Font, true);

type TemplateEditorProps = {
  value: string;
  onChange: (value: string) => void;
  nameTemplate: string;
  setNameTemplate: (value: string) => void;
  openAddTemplate: { open: boolean; id: string };
};

const TemplateEditor: React.FC<TemplateEditorProps> = ({
  value,
  onChange,
  nameTemplate,
  setNameTemplate,
  openAddTemplate,
}) => {
  const { createTemplates, updateTemplates } = useTemplates();
  const [editorHtml, setEditorHtml] = useState(value);
  const editor = useRef(null);

  const handleChange = (html: string) => {
    setEditorHtml(html);
    onChange(html);
  };

  const handleSave = () => {
    if (openAddTemplate.id) {
      updateTemplates(openAddTemplate.id, nameTemplate, editorHtml);
    } else {
      createTemplates(nameTemplate, editorHtml);
    }
  };

  return (
    <div>
      <div className="d-flex mb-3">
        <Col xs="6" className="mb-3 p-0 mr-4">
          <InputStandard
            type="text"
            name="nameTemplate"
            handleChange={(valueAtt: string, name: string) =>
              setNameTemplate(valueAtt)
            }
            value={nameTemplate}
            label="Nome do Modelo"
          />
        </Col>
      </div>

      <Card
        className="mb-3"
        style={{ backgroundColor: "#f8f9fa", border: "1px solid #ddd" }}
      >
        <CardBody>
          <h5 className="mb-2">ℹ️ Como usar variáveis no seu template</h5>
          <p>
            Você pode usar <strong>campos dinâmicos</strong> dentro do seu texto
            para gerar contratos personalizados automaticamente. Para isso,
            utilize <strong>duas chaves no início e duas chaves no fim</strong>{" "}
            da palavra, assim:
          </p>
          <code>
            {"{"}
            {"{"}NOME{"}"}
            {"}"}
          </code>
          <p className="mt-2">
            Durante o uso do template, esse texto será substituído pelo{" "}
            <strong>nome real da pessoa</strong>.
          </p>
          <p>Outros exemplos de campos que você pode usar:</p>
          <ul>
            <li>
              <code>
                {"{"}
                {"{"}ENDERECO{"}"}
                {"}"}
              </code>{" "}
              → será substituído pelo endereço
            </li>
            <li>
              <code>
                {"{"}
                {"{"}CPF{"}"}
                {"}"}
              </code>{" "}
              → será substituído pelo CPF
            </li>
            <li>
              <code>
                {"{"}
                {"{"}DATA{"}"}
                {"}"}
              </code>{" "}
              → será substituído pela data atual
            </li>
          </ul>
        </CardBody>
      </Card>

      <Col xs="12" className="mb-3 p-0">
        <ReactQuill
          ref={editor}
          value={editorHtml}
          onChange={handleChange}
          theme="snow"
          modules={modules}
          formats={formats}
          style={{ height: "400px", backgroundColor: "#fff" }}
        />
      </Col>

      <div className="d-flex justify-content-end mt-6 mr-3">
        <Col xs="2" className=" p-0">
          <Button className="button-login" onClick={() => handleSave()} block>
            Salvar
          </Button>
        </Col>
      </div>
    </div>
  );
};

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
  "align",
];

export default TemplateEditor;
